import { render, staticRenderFns } from "./BranchRoleDelete.vue?vue&type=template&id=6bc210f8&scoped=true&"
import script from "./BranchRoleDelete.vue?vue&type=script&lang=js&"
export * from "./BranchRoleDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc210f8",
  null
  
)

export default component.exports